/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaTwitter16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.034 1 6.44 8.24 1 14.124h1.224l4.762-5.153 3.848 5.153H15L9.29 6.479 14.354 1H13.13L8.744 5.746 5.2 1zm1.8.903h1.914L13.2 13.222h-1.913z"
    />
  </svg>
);

export const __descriptor_SocialMediaTwitter = {
  name: "SocialMediaTwitter",
  instances: [{ size: 16, Component: SocialMediaTwitter16 }],
} as const;
